import React from 'react';

const PROGRAMS = [
    {
        tier: "Apprenticeship",
        name: "2027 Startup Sprint",
        duration: "14-Day Intensive",
        href: "/admissions/2027-startup-sprint",
        accentColor: "#3769B9",
        details: [
            { label: "Duration", value: "14 days" },
            { label: "Pace", value: "Sprint — fast, focused, high intensity" },
            { label: "Team size", value: "5 externs" },
            { label: "Product outcome", value: "Working prototype launched by Deployment Day" },
            { label: "Iteration cycles", value: "One major build → launch" },
            { label: "Time per week", value: "~5–10 hours" },
            { label: "Portfolio outcome", value: "A launched product (live for 1 year)" },
            { label: "Tuition", value: "$850" },
        ],
        best: "Students who want a concentrated, high-energy first experience building something from scratch.",
    },
    {
        tier: "Mastery",
        name: "Founder Track",
        duration: "28-Day Externship",
        href: "/admissions/founder-track",
        accentColor: "#D23C1E",
        details: [
            { label: "Duration", value: "28 days" },
            { label: "Pace", value: "Marathon — deeper exploration, more iteration" },
            { label: "Team size", value: "10 externs" },
            { label: "Product outcome", value: "Polished product with real user feedback and iteration" },
            { label: "Iteration cycles", value: "Multiple build → test → refine cycles" },
            { label: "Time per week", value: "~8–12 hours" },
            { label: "Portfolio outcome", value: "A refined product with user metrics and testimonials" },
            { label: "Tuition", value: "$2,200" },
        ],
        best: "Students who want to go deeper, iterate, and build a more market-ready product.",
    },
    {
        tier: "Pure Gold",
        name: "The Residency",
        duration: "48-Day Intensive Externship",
        href: "/admissions/residency",
        accentColor: "#CDAF4B",
        details: [
            { label: "Duration", value: "48 days" },
            { label: "Pace", value: "Full cycle — strategy, build, launch, and scale" },
            { label: "Team size", value: "Select cohort" },
            { label: "Product outcome", value: "Market-ready product with active users and growth metrics" },
            { label: "Iteration cycles", value: "Continuous build → measure → scale loops" },
            { label: "Time per week", value: "~12–15 hours" },
            { label: "Portfolio outcome", value: "A live company with traction, ready to pitch" },
            { label: "Tuition", value: "By application" },
        ],
        best: "Students ready to commit fully — building, launching, and scaling a startup from the ground up over 48 days.",
    },
];

export default function ComparisonTable() {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            {PROGRAMS.map((program) => (
                <div
                    key={program.tier}
                    className="rounded-xl overflow-hidden flex flex-col"
                    style={{ border: `2px solid ${program.accentColor}` }}
                >
                    {/* Card header */}
                    <div className="p-5 text-white" style={{ backgroundColor: program.accentColor }}>
                        <p className="text-xs font-semibold uppercase tracking-widest mb-1" style={{ opacity: 0.75 }}>
                            {program.tier}
                        </p>
                        <h3 className="text-xl font-bold mb-0">{program.name}</h3>
                        <p className="text-sm mt-1" style={{ opacity: 0.85 }}>{program.duration}</p>
                    </div>

                    {/* Details */}
                    <div className="bg-white flex-1 p-5">
                        <ul className="list-unstyled mb-4" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {program.details.map(({ label, value }) => (
                                <li key={label} className="text-sm">
                                    <span className="font-semibold text-gray-700">{label}: </span>
                                    <span className="text-gray-500">{value}</span>
                                </li>
                            ))}
                        </ul>

                        <div className="rounded-lg p-3 mt-4" style={{ background: "#f9fafb", border: "1px solid #e5e7eb" }}>
                            <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-1">Best for</p>
                            <p className="text-sm text-gray-600 mb-0">{program.best}</p>
                        </div>
                    </div>

                    {/* CTA */}
                    <a
                        href={program.href}
                        className="block text-center text-sm font-semibold py-3 text-white text-decoration-none"
                        style={{ backgroundColor: program.accentColor }}
                    >
                        Learn more →
                    </a>
                </div>
            ))}
        </div>
    );
}
